module.exports = __webpack_public_path__ + "media/music/synth_chords_7-63f82dc5.mp3";